"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CT_SQG_ACCUMULATION_THRESHOLD_KG = exports.MN_ACCUMULATION_THRESHOLD_ACUTE_KG = exports.MN_VSQG_ACCUMULATION_THRESHOLD_KG = exports.MN_SQG_ACCUMULATION_THRESHOLD_KG = exports.SQG_ACCUMULATION_THRESHOLD_KG = exports.VSQG_ACCUMULATION_THRESHOLD_ACUTE_KG = exports.VSQG_ACCUMULATION_THRESHOLD_KG = exports.TEXAS_CLASS_1_ONLY_KG = exports.KSQG_THRESHOLD_HAZARDOUS_KG = exports.LQG_THRESHOLD_HAZARDOUS_LB = exports.LQG_THRESHOLD_HAZARDOUS_KG = exports.SQG_THRESHOLD_HAZARDOUS_LB = exports.SQG_THRESHOLD_HAZARDOUS_KG = exports.VSQG_THRESHOLD_HAZARDOUS_LB = exports.VSQG_THRESHOLD_HAZARDOUS_KG = exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = void 0;
exports.kilogramsExceed = kilogramsExceed;
exports.kilogramsReach = kilogramsReach;
exports.poundsExceed = poundsExceed;
exports.poundsReach = poundsReach;
exports.formatPounds = formatPounds;
exports.formatThresholdPounds = formatThresholdPounds;
// Federal Generator Status Thresholds (40 CFR 260.10)
//
// The tiers are defined in kilograms, so the `*_KG` constants are the rule and
// the `*_LB` figures are the rounded presentation the regulation prints beside
// them — 220 lb is 99.79 kg, not 100 kg. Classify mass with the comparisons at
// the bottom of this file against a `*_KG` threshold; the `*_LB` constants are
// for display (chart reference lines, rule tables, prose).
exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_KG = 1;
exports.LQG_THRESHOLD_ACUTE_HAZARDOUS_LB = 2.2;
exports.VSQG_THRESHOLD_HAZARDOUS_KG = 0;
exports.VSQG_THRESHOLD_HAZARDOUS_LB = 0;
exports.SQG_THRESHOLD_HAZARDOUS_KG = 100;
exports.SQG_THRESHOLD_HAZARDOUS_LB = 220;
exports.LQG_THRESHOLD_HAZARDOUS_KG = 1000;
exports.LQG_THRESHOLD_HAZARDOUS_LB = 2200;
// Kansas Small Quantity Generator (K.A.R. 28-31-4) — 25 kg, printed as 55 lb
exports.KSQG_THRESHOLD_HAZARDOUS_KG = 25;
// Texas Class 1 Only Threshold — 100 kg, printed as 220 lb
exports.TEXAS_CLASS_1_ONLY_KG = 100;
// (40 CFR 262.14/262.16)
// max on-site at any time (distinct from monthly generation)
exports.VSQG_ACCUMULATION_THRESHOLD_KG = 1000;
exports.VSQG_ACCUMULATION_THRESHOLD_ACUTE_KG = 1;
exports.SQG_ACCUMULATION_THRESHOLD_KG = 6000;
// (Minn. R. 7045.0292)
// max on-site at any time (distinct from monthly generation)
exports.MN_SQG_ACCUMULATION_THRESHOLD_KG = 3000;
exports.MN_VSQG_ACCUMULATION_THRESHOLD_KG = 1000;
exports.MN_ACCUMULATION_THRESHOLD_ACUTE_KG = 1;
// (RCSA § 22a-449(c)-102, modifying 40 CFR 262.34(d) as of July 1, 2000)
// max on-site at any time (distinct from monthly generation)
exports.CT_SQG_ACCUMULATION_THRESHOLD_KG = 1000;
/** Exact by definition: the international pound is 0.45359237 kg. */
const KILOGRAMS_PER_POUND = 0.45359237;
/**
 * Slack allowed on a threshold comparison, in kilograms. A month recorded as a
 * round 100 kg arrives as a float sum that can land either side of the
 * threshold by a few ulps — and on the pound-denominated calculators only after
 * a kg → lb → kg round trip. A milligram of slack keeps that dust from deciding
 * a tier; no real determination turns on it.
 */
const THRESHOLD_TOLERANCE_KG = 1e-6;
/** Mass is strictly above the threshold — for rules phrased "more than N kg". */
function kilogramsExceed(massKg, thresholdKg) {
    return massKg > thresholdKg + THRESHOLD_TOLERANCE_KG;
}
/** Mass is at or above the threshold — for rules phrased "N kg or more". */
function kilogramsReach(massKg, thresholdKg) {
    return massKg > thresholdKg - THRESHOLD_TOLERANCE_KG;
}
/** {@link kilogramsExceed} for a mass measured in pounds. */
function poundsExceed(massLb, thresholdKg) {
    return kilogramsExceed(massLb * KILOGRAMS_PER_POUND, thresholdKg);
}
/** {@link kilogramsReach} for a mass measured in pounds. */
function poundsReach(massLb, thresholdKg) {
    return kilogramsReach(massLb * KILOGRAMS_PER_POUND, thresholdKg);
}
/** Pounds as generator status screens show them: grouped, at most one decimal. */
function formatPounds(pounds) {
    return pounds.toLocaleString("en-US", { maximumFractionDigits: 1 });
}
/** A kg threshold in pounds, rounded like the waste totals it's read against. */
function formatThresholdPounds(thresholdKg) {
    return formatPounds(thresholdKg / KILOGRAMS_PER_POUND);
}
//# sourceMappingURL=wasteGeneratorStatusThresholds.js.map